"use client";

import { motion } from "framer-motion";
import  ceo from "../accests/common/ceo.jpeg"

export default function CEO() {
    return (
        <section className="bg-gradient-to-b from-gray-950 to-gray-900 text-gray-300 py-20">
            <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">

                {/* CEO Image */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="flex justify-center"
                >
                    <img
                        src={ceo}
                        alt="Dilan Jayamal - CEO of Ranmali Tours"
                        className="w-72 h-72 object-cover rounded-2xl shadow-xl border border-gray-700"
                    />
                </motion.div>

                {/* CEO Content */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7 }}
                >
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
                        Founder & Chief Executive Officer
                    </h2>

                    <h3 className="text-xl text-yellow-400 font-semibold mb-4">
                        Dilan Jayamal
                    </h3>

                    <p className="text-gray-400 leading-relaxed mb-5">
                        I am <span className="text-white font-medium">Dilan Jayamal</span>, Founder and CEO of
                        <span className="text-white font-medium"> Ranmali Tours</span>.
                        Our mission is to create unforgettable travel experiences while showcasing
                        the natural beauty, culture, and hospitality of Sri Lanka.
                    </p>

                    <p className="text-gray-400 leading-relaxed mb-6">
                        Ranmali Tours was established with a passion for responsible tourism,
                        personalized journeys, and exceptional customer care.
                        We believe every journey should be meaningful, comfortable, and memorable.
                    </p>

                    {/* Vision & Mission */}
                    <div className="grid sm:grid-cols-2 gap-6">
                        <div className="bg-gray-800/40 p-5 rounded-xl border border-gray-700">
                            <h4 className="text-white font-semibold mb-2">Our Vision</h4>
                            <p className="text-gray-400 text-sm">
                                To become a trusted tourism brand that introduces Sri Lanka to the world
                                through authentic and memorable travel experiences.
                            </p>
                        </div>

                        <div className="bg-gray-800/40 p-5 rounded-xl border border-gray-700">
                            <h4 className="text-white font-semibold mb-2">Our Mission</h4>
                            <p className="text-gray-400 text-sm">
                                To deliver high-quality, personalized, and safe tours while promoting
                                sustainable and responsible tourism.
                            </p>
                        </div>
                    </div>
                </motion.div>

            </div>
        </section>
    );
}
